module.exports = __webpack_public_path__ + "static/media/potatoe-heart-1.91a240ac.jpg";